module.exports = "/fonts/vendor/devextreme/dist/css/icons/dxicons.woff2?d09f619b693e54f5895b0876c50142cd";